import { render, staticRenderFns } from "./InstallChuti.vue?vue&type=template&id=0a83c462&scoped=true&"
import script from "./InstallChuti.vue?vue&type=script&lang=ts&"
export * from "./InstallChuti.vue?vue&type=script&lang=ts&"
import style0 from "./InstallChuti.vue?vue&type=style&index=0&id=0a83c462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83c462",
  null
  
)

component.options.__file = "InstallChuti.vue"
export default component.exports